import React from 'react';
import cc from 'classcat';
import { LeaveRequestStatus } from '../../../commonTypes/leaveRequest.types';

interface IRequestStatus {
    status: LeaveRequestStatus;
    reason?: string;
    openDetails: (reason: string) => void;
    children?: React.ReactNode;
}

export const RequestStatus = ({ status, reason, openDetails, children }: IRequestStatus) => {
    return (
        <div className={cc(['request-status', `request-status--${status.toLocaleLowerCase()}`])}>
            <span className="request-status__text">{status}</span>
            {reason && (
                <button className="request-status__reason" onClick={() => openDetails(reason)}>
                    <img src="/svg/comment.svg" alt="Comment" />
                </button>
            )}
            {children}
        </div>
    );
};
